import { Provider } from "@xola/ui-kit";
import React, { ReactNode, useEffect, useState } from "react";
import { useLocalizationStore } from "../stores/localizationStore";

interface UiKitProviderProps {
    children: ReactNode;
}

export const UiKitProvider = ({ children }: UiKitProviderProps) => {
    const locale = useLocalizationStore().getLocale();
    const [currentLocale, setCurrentLocale] = useState<string>();

    useEffect(() => {
        setCurrentLocale(locale);
    }, [locale]);

    return (
        <Provider key={currentLocale} localize locale={currentLocale}>
            {children}
        </Provider>
    );
};
